import { makeStyles } from '@material-ui/styles'
import Text from 'pf9-ui-components/built/elements/Text'
import React from 'react'
import ExternalLink from 'core/components/ExternalLink'
import type Theme from 'core/themes/model'
import {
  CONTROL_PLANE_TYPES_DOCS_LINK_TEXT,
  CONTROL_PLANE_TYPES_DOCS_URL,
  colocatedControlPlaneCard,
  managedControlPlaneCard,
} from './controlPlaneTypes'
import SelectableCardWrapper from './SelectableCardWrapper'

/**
 * Cluster Architecture Fields component
 * @param param0 - params, getParamsUpdater, physicalNodeErrors
 * @returns Cluster Architecture Fields component is used for cluster architecture selection for BYO infrastructure
 */
export default function ClusterArchitectureFieldsBYO({
  params,
  getParamsUpdater,
  updateParams,
  physicalNodeErrors,
  setError,
}) {
  const classes = useStyles()
  const handleControlPlaneTypeChange = (type) => {
    updateParams({
      controlPlaneType: type,
      // Clear master nodes when switching away from custom
      ...(type !== 'custom' && { masterPhysicalNodes: [] }),
    })
  }
  return (
    <>
      {/* Select OpenStack Infrastructure */}
      <div className={classes.clusterArchitectureFields}>
        <div className={classes.controlPlaneOptions}>
          <Text variant="body2">Select the type of control plane.</Text>
          <div className={classes.SelectableCardWrappers}>
            <SelectableCardWrapper
              id="managed"
              onClick={() => handleControlPlaneTypeChange('managed')}
              active={params?.controlPlaneType === 'managed'}
              title="Managed Control Plane"
              description={managedControlPlaneCard.description}
              info={managedControlPlaneCard.info}
            />
            <SelectableCardWrapper
              id="custom"
              onClick={() => handleControlPlaneTypeChange('custom')}
              active={params?.controlPlaneType === 'custom'}
              title="Colocated Control Plane"
              description={colocatedControlPlaneCard.description}
              info={colocatedControlPlaneCard.info}
            />
          </div>
          <ExternalLink url={CONTROL_PLANE_TYPES_DOCS_URL}>
            {CONTROL_PLANE_TYPES_DOCS_LINK_TEXT}
          </ExternalLink>
        </div>
      </div>
    </>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  clusterArchitectureFields: {
    display: 'grid',
    gridGap: theme.spacing(2),
  },
  controlPlaneOptions: {
    display: 'grid',
    margin: theme.spacing(2, 0),
    gridGap: theme.spacing(2),
  },
  SelectableCardWrappers: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gridGap: theme.spacing(2),
  },
}))
